module.exports = __webpack_public_path__ + "img/11069855_L.4abb830a.png";